import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { resolveFilterOption } from "../../merchandising/components/tables/resolveFilterOption";

const PROMOTION_TYPES = [
  { value: "Best Deal", label: ($) => $.advertising["Best Deal"] },
  { value: "Lightning Deal", label: ($) => $.advertising["Lightning Deal"] },
  { value: "Price Discount", label: ($) => $.advertising["Price Discount"] },
];

const PROMOTION_STATUS = [
  { value: "Approved", label: ($) => $.advertising["Approved"] },
  { value: "In Progress", label: ($) => $.advertising["In Progress"] },
  { value: "Completed", label: ($) => $.advertising["Completed"] },
  { value: "Canceled", label: ($) => $.advertising["Canceled"] },
];

export const PROMOTION_STATUS_FILTER = {
  name: ($) => $.advertising["Status"],
  id: "status",
  format: "select",
  selectOptions: [
    {
      value: "all",
      label: ($) => $.advertising["All Statuses"],
    },
    ...PROMOTION_STATUS,
  ],
  override: true,
  defaultValue: "all",
  operator: "custom",
  filterFunction: (promo, filterValue) => {
    if (filterValue !== "all") {
      return promo.status === filterValue;
    }
    return true;
  },
};

export const PROMOTION_TYPE_FILTER = {
  name: ($) => $.advertising["Type"],
  id: "promotionType",
  format: "select",
  selectOptions: [
    {
      value: "all",
      label: ($) => $.advertising["All Types"],
    },
    ...PROMOTION_TYPES,
  ],
  override: true,
  defaultValue: "all",
  operator: "custom",
  filterFunction: (promo, filterValue) => {
    if (filterValue !== "all") {
      return promo.promotionType === filterValue;
    }
    return true;
  },
};

// Resolves the advertising-namespace selectors carried by the filter defs above
// into plain strings, bound to the `advertising` namespace at the call site so
// the generic FilterWidget never has to resolve them. See resolveFilterOption.
export function usePromotionReportFilters() {
  const { t } = useTranslation(["advertising"]);
  return useMemo(
    () => ({
      PROMOTION_STATUS_FILTER: resolveFilterOption(t, PROMOTION_STATUS_FILTER),
      PROMOTION_TYPE_FILTER: resolveFilterOption(t, PROMOTION_TYPE_FILTER),
    }),
    [t],
  );
}
